export default __webpack_public_path__ + "static/blob10-f9b83935117996f1a714ab1408458fff.svg";